import { useContracts } from "@ip-modules/contract";

import Select from "../index";

export default function Contract(props) {
  const { contracts } = useContracts();

  const items = [...new Set(contracts?.map((item) => item.status))];

  return <Select label="Status" items={items} {...props} />;
}
